/* global axios */
import ApiClient from '../ApiClient';

class ElectoralCampaignPinsAPI extends ApiClient {
  constructor() {
    super('electoral_campaign/pins', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  list({ pinType, includeWorkers = true } = {}) {
    const params = {};
    if (pinType) params.pinType = pinType;
    if (includeWorkers) params.includeWorkers = true;
    return axios.get(this.url, { params });
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ElectoralCampaignPinsAPI();
